module.exports = __webpack_public_path__ + "static/contact1-fc4faf39a2d3a585978d871491e72ed5.png";